import { TokenService } from './token.service'
import { ApiService } from '../api'
import { store } from '@/modules/store/store-module'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'
import Vue from 'vue'

class AuthenticationError extends Error {
  constructor (public errorCode: any, message: string) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    this.errorCode = errorCode
  }
}

const UserAuthService = {
  /**
     * Login the user and store the access token to TokenService.
     *
     * @returns access_token
     * @throws AuthenticationError
    **/
  login: async function (email: string, password: string): Promise<boolean> {
    const requestData = {
      method: 'POST',
      url: 'auth/token/',
      header: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        client_id: process.env.VUE_APP_APPLICATION_CLIENT_ID,
        client_secret: process.env.VUE_APP_APPLICATION_SECRET,
        grant_type: 'password',
        username: email,
        password: password,
        scope: 'read write'
      }
    }

    try {
      const response = await ApiService.customRequest(requestData)

      TokenService.saveToken(response.data.access_token)
      TokenService.saveRefreshToken(response.data.refresh_token)
      ApiService.mount401Interceptor()

      return response.data.access_token
    } catch (error) {
      console.log(error)
      throw new AuthenticationError(error.response.status, error.response.data.detail)
    }
  },

  /**
     * Refresh the access token.
    **/
  refreshToken: async function () {
    // Remove the authentication token from header before calling refresh if not it doesn't work
    const refreshToken = TokenService.getRefreshToken()

    const requestData = {
      method: 'post',
      url: process.env.VUE_APP_API_BACKEND_URL + 'auth/token/',
      header: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json;charset=UTF-8'
        // 'Access-Control-Allow-Origin': '*'
      },
      data: {
        client_id: process.env.VUE_APP_APPLICATION_CLIENT_ID,
        client_secret: process.env.VUE_APP_APPLICATION_SECRET,
        grant_type: 'refresh_token',
        refresh_token: refreshToken
      }
    }

    try {
      const response = await ApiService.customRequest(requestData)

      TokenService.saveToken(response.data.access_token)
      TokenService.saveRefreshToken(response.data.refresh_token)

      return response.data.access_token
    } catch (error) {
      console.log(error)
      // TokenService.removeToken();
      // TokenService.removeRefreshToken();
      throw new AuthenticationError(error.response.status, error.response.data.detail)
    }
  },

  refreshTokenPromise: null,
  refreshTokenInterceptor: async function () {
    if (!this.refreshTokenPromise) {
      const p = this.refreshToken()
      this.refreshTokenPromise = p

      // Wait for the UserService.refreshToken() to resolve. On success set the token and clear promise
      // Clear the promise on error as well.
      p.then(
        response => {
          this.refreshTokenPromise = null
          TokenService.saveToken(response.accessToken)
          store.commit('userLogIn')
        },
        error => {
          this.refreshTokenPromise = null
        }
      )
    }
    return this.refreshTokenPromise
  },

  /**
     * Logout the current user by removing the token from storage.
     *
     * Will also remove `Authorization Bearer <token>` header from future requests.
    **/
  logout () {
    // Remove the token and remove Authorization header from Api Service as well
    TokenService.removeToken()
    TokenService.removeRefreshToken()
    ApiService.unmount401Interceptor()
    store.commit('userLogOut')
    store.dispatch('snackbar/activate', { message: 'has cerrado session o ha expirado', code: 1 })
  }
}

const vueAuth = VueAuthenticate.factory(axios, {
  providers: {
    linkedin: {
      clientId: '860a9egnzmfo19',
      redirectUri: 'http://localhost:8080/',
      url: 'http://localhost:8000/api/login/social/token_user/linkedin-oauth2/',
      scope: ['r_emailaddress', 'r_liteprofile', 'w_member_social'],
      requiredUrlParams: ['state', 'scope'],
      tokenPath: 'token'
    }
  }
})

const AuthSocialMixin = {

  checkToken (provider, redirect) {
    axios.post('http://localhost:8000/api/check/', { 'token': localStorage.getItem('vue-authenticate.vueauth_token') }).then((response) => {
      var path = (response.data.status) ? true : '/'
      redirect({ path: path })
    }).catch((error) => {
      console.error(error)
    })
  },
  authenticate (provider) {
    vueAuth.authenticate('linkedin').then(function (response) {
      console.info(response)
    }).catch(function (error) {
      console.log(error)
    })
  }

}

export { UserAuthService, AuthenticationError, AuthSocialMixin }
